import { render, staticRenderFns } from "./pos-ticket-tabs.vue?vue&type=template&id=58ba7e2b&scoped=true&"
import script from "./pos-ticket-tabs.vue?vue&type=script&lang=ts&"
export * from "./pos-ticket-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./pos-ticket-tabs.vue?vue&type=style&index=0&id=58ba7e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba7e2b",
  null
  
)

export default component.exports